import { getPageCache, setPageCache } from './pageCache';

/**
 * Cache key for a public cookbook page (`/u/:userId`).
 *
 * Keyed by viewer as well as owner: `isOwner` and private-recipe visibility
 * depend on who is looking, so one viewer's copy must never seed another's.
 */
export const publicProfileCacheKey = (
  userId: string | null | undefined,
  viewerUid: string | undefined
): string | null => (userId ? `public-profile:${userId}:${viewerUid ?? 'anon'}` : null);

export type PublicProfileOwner = {
  uid: string;
  displayName?: string;
  photoURL?: string;
};

/**
 * Fold a name/photo edit into the owner's own cached copy of their public
 * profile, so opening it after editing elsewhere (the Preferences page)
 * paints the new name rather than the seeded old one.
 */
export const patchCachedPublicProfileOwner = (
  uid: string | undefined,
  owner: Omit<PublicProfileOwner, 'uid'>
): void => {
  const key = publicProfileCacheKey(uid, uid);
  const cached = getPageCache<{ owner: PublicProfileOwner | null }>(key);
  if (!cached || !uid) return;
  setPageCache(key, {
    ...cached,
    owner: { ...owner, uid },
  });
};
